// @mui
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

export default function SelectPlanWarnDialog({ isOpen, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
        <Typography
          variant={smUp ? "h5" : "subtitle1"}
          gutterBottom
        >
          계약 플랜을 먼저 선택해주세요.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2"}>
          계약 플랜 중 하나를 선택하면 사전 미팅을 예약 할 수 있습니다. 최종 계약 플랜은 미팅 이후 변경할 수 있습니다.
        </Typography>

      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          variant="contained"
          size="large"
          sx={{ px: 6 }}
          onClick={closeDialog}
          fullWidth={!smUp}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}